import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Bus, Car, CalendarClock, ShieldCheck, Smartphone, Users, MapPin, TrendingUp, Calendar, Plane } from "lucide-react";

export default function Services() {
  const processSteps = [
    {
      id: 1,
      title: "Analysis",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
      desc: "Workride pro. analyzes the status quo of your corporate mobility and our algorithm delivers the best routes for a employee transport together with a demand prediction for each route and bus stop."
    },
    {
      id: 2,
      title: "Implementation",
      image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d",
      desc: "Workride pro. finds the perfect bus operator, covers the legal paperwork and sets everything up for the employee transport to go into service. You don't have to worry about anything."
    },
    {
      id: 3,
      title: "Operation",
      image: "https://images.unsplash.com/photo-1512428559087-560fa0db7f59",
      desc: "Workride pro. ensures a seamless operating of the entire fleet. We handle the billing, constantly optimize routes and give your employees the user experience they deserve."
    }
  ];

  const services = [
    {
      icon: Bus,
      title: "ETS-One",
      desc: "Safe, reliable, and punctual daily commute solutions for your workforce. We manage end-to-end logistics, ensuring employees arrive fresh and on time."
    },
    {
      icon: Car,
      title: "Vendor Management",
      desc: "Comprehensive fleet oversight including vehicle procurement, maintenance, compliance checks, and driver training to ensure optimal performance."
    },
    {
      icon: ShieldCheck,
      title: "Monitoring Compliance & Safety",
      desc: "Rigorous adherence to statutory regulations. Features include real-time tracking, panic buttons, background-verified drivers, and 24/7 command center monitoring."
    },
    {
      icon: Smartphone,
      title: "Forensic and Audit Insights",
      desc: "Deep-dive analytics and compliance audits to uncover inefficiencies and ensure financial transparency. We provide detailed forensic reports on trip data, billing accuracy, and adherence to safety protocols."
    },
    {
      icon: MapPin,
      title: "Home Stretch",
      desc: "Seamless connectivity from your doorstep to the nearest Metro Station. We bridge the gap between your home and public transit, ensuring a hassle-free start and end to your daily commute."
    },
    {
      icon: Users,
      title: "Ride On Coattails",
      desc: "Collaborative commute solutions for tech parks and business districts. Organizations in the same vicinity can share shuttle services, reducing costs and carbon footprint while maximizing fleet utilization."
    },
    {
      icon: TrendingUp,
      title: "CE-Improvement",
      desc: "Customer Experience Improvement programs designed to enhance employee satisfaction. We use feedback loops, comfort upgrades, and personalized services to turn the daily commute into a perk."
    },
    {
      icon: Calendar,
      title: "Events & Expo",
      desc: "Specialized transport logistics for corporate events, conferences, and expos. We handle large-scale movement of delegates with precision timing and premium vehicles."
    },
    {
      icon: Plane,
      title: "Business Travel",
      desc: "End-to-end management of corporate travel needs, including airport transfers, outstation cabs, and executive car rentals, ensuring a seamless travel experience for your team."
    }
  ];

  return (
    <section id="services" className="dark py-24 bg-background text-foreground">
      <div className="container mx-auto px-6">
        
        {/* Process Section */}
        <div className="mb-24">
          <div className="text-center max-w-4xl mx-auto mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-primary mb-6">
              We set up your corporate mobility service from scratch
            </h2>
            <p className="text-lg text-muted-foreground">
              From initial analysis to daily operations, we handle every aspect of your employee transport.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {processSteps.map((step) => (
              <Card key={step.id} className="border-none shadow-lg bg-card hover:-translate-y-1 transition-transform duration-300 overflow-hidden group">
                <CardHeader>
                  <CardTitle className="text-2xl font-bold text-primary">{step.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {step.desc}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Services Grid */}
        <div>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">Our Solutions</h2>
            <p className="text-lg text-muted-foreground">
              Comprehensive mobility services designed to meet the evolving needs of modern enterprises.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, idx) => (
              <Card key={idx} className="border-none shadow-lg hover:shadow-xl transition-all duration-300 group bg-card">
                <CardHeader>
                  <div className="w-14 h-14 rounded-xl bg-secondary/10 flex items-center justify-center mb-4 group-hover:bg-secondary group-hover:text-white transition-colors duration-300">
                    <service.icon className="h-7 w-7 text-secondary group-hover:text-white" />
                  </div>
                  <CardTitle className="text-xl font-bold text-primary">{service.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {service.desc}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
